const cfdDelinquencyReport = {
  label: "CFD Delinquency Report",
  name: "cfdDelinquencyReport",
  parameters: [
    {
      name: "db",
      label: "Database",
      type: "select",
      defaultValue: "cfd",
      options: [
        { key: "cfd", label: "cfd" },
        { key: "cfddev", label: "cfddev" },
        { key: "cfddev_staging", label: "cfddev_staging" },
      ],
    },
    {
      name: "taxYear",
      label: "Tax Year",
      type: "year",
      defaultValue: "2025",
    },
    {
      name: "countyId",
      label: "County",
      type: "dbfield",
      table: "County",
      keyField: "CountyId",
      valueField: "Name",
      fields: ["County.CountyId", "County.Name"],
      distinct: true,
      join: {
        District: "CountyId",
      },
      sort: {
        Name: "asc",
      },
    },
    {
      name: "districtId",
      label: "District",
      type: "dbfield",
      table: "District",
      keyField: "DistrictId",
      valueField: "Name",
      fields: ["District.DistrictId", "District.Name"],
      distinct: true,
      sort: {
        Name: "asc",
      },
      dependsOn: "countyId",
      noDependsOnDisable: true,
    },
  ],
};

export default cfdDelinquencyReport;
